// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FileInput input{display:none}", "",{"version":3,"sources":["webpack://./src/components/FileInput/FileInput.scss"],"names":[],"mappings":"AAKI,iBACI,YAAA","sourcesContent":[".FileInput {\r\n    .Button {\r\n\r\n    }\r\n\r\n    input {\r\n        display: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
